import type { Dict } from "../core.js";
import type { dependencies as vi } from "../vi/dependencies.js";

export const dependencies: Dict<typeof vi> = {
  title: "Dependencies",
  loadFailed: "Couldn't load the dependency graph.",
  introMiddle: " means ",
  introStrong: "A needs B",
  introAfter: " to run. Sorted by « how many things need it » — if a node near the top breaks, many things break.",
  cycles: "{count} cycles in runtime dependencies — no startup order is correct.",
  cyclesNote:
    "Cycles work day to day because every side is already up — they only surface when the whole cluster is redeployed at once.",
  emptyTitle: "The catalog declares no dependencies yet.",
  emptyBefore: "Dependencies are declared in source manifests and loaded with ",
  emptyMiddle: ". Empty here means ",
  emptyStrong: "not declared",
  emptyAfter: ", not « the services are independent of each other ».",
  "col.service": "Service",
  "col.tier": "Tier",
  "col.dependents": "How many need it",
  "col.needs": "Needs",
  "col.neededBy": "Needed by",
};
